import { createCrudSlice, createCrudSelectors } from "./CrudRedux"

const recordingsSlice = createCrudSlice({
  name: "recordings",
});

export const RecordingsActions = recordingsSlice.actions;

export const RecordingsSelectors = {
  ...createCrudSelectors({ name: "recordings" }),
};

export default recordingsSlice.reducer;
